const EventList = () => {
  return <div>EventList</div>
}

export default EventList
